import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Lodash
import _noop from 'lodash/noop';
import _isArray from 'lodash/isArray';
import _isEqual from 'lodash/isEqual';
import _min from 'lodash/min';

// Component
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { tget } from '@tekion/tekion-base/utils/general';

// Helpers
import { EVENTS, getEventListenerWithBlockedEvents } from '../../../../helpers/eventListenerHelpers';
import { getMenuHeight, getFocusedOptionIndex } from './menuList.helpers';

// Constants
import { ROW_HEIGHT, OVERSCAN_ROW_COUNT } from './menuList.constants';

// Styles
import s from './menuList.module.scss';
var MenuList = /*#__PURE__*/function (_PureComponent) {
  _inherits(MenuList, _PureComponent);
  var _super = _createSuper(MenuList);
  function MenuList(props) {
    var _this;
    _classCallCheck(this, MenuList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "replaceAddEventListener", function () {
      var menuListRef = _this.autoSizerRef.current._autoSizer;
      var addEventListener = menuListRef.addEventListener;
      menuListRef.addEventListener = getEventListenerWithBlockedEvents(addEventListener, [EVENTS.WHEEL]);
    });
    _defineProperty(_assertThisInitialized(_this), "renderPlaceholder", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: s.placeHolderWrapper
      }, __('No Match Found'));
    });
    _defineProperty(_assertThisInitialized(_this), "renderMenuListItem", function (_ref) {
      var key = _ref.key,
        index = _ref.index,
        style = _ref.style,
        parent = _ref.parent;
      var options = _this.props.children;
      return /*#__PURE__*/React.createElement(CellMeasurer, {
        key: key,
        cache: _this.cache,
        parent: parent,
        columnIndex: 0,
        rowIndex: index
      }, /*#__PURE__*/React.createElement("div", {
        style: style,
        className: s.menuListItem
      }, options[index]));
    });
    _this.autoSizerRef = /*#__PURE__*/React.createRef();
    _this.listRef = /*#__PURE__*/React.createRef();
    var cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: ROW_HEIGHT
    });
    _this.cache = cache;
    return _this;
  }
  _createClass(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (tget(this, 'autoSizerRef.current._autoSizer', false)) {
        this.replaceAddEventListener();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevOptions = prevProps.children;
      var currentOptions = this.props.children;
      if (!_isEqual(prevOptions, currentOptions)) {
        this.cache.clearAll();
        this.listRef.current.forceUpdateGrid();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        options = _this$props.children,
        getStyles = _this$props.getStyles,
        maxHeight = _this$props.maxHeight,
        shouldScrollToIndex = _this$props.shouldScrollToIndex,
        height = _this$props.height;
      var optionSize = _isArray(options) ? options.length : 0;
      var menuHeight = getMenuHeight(optionSize);
      var focusedOptionIndex = shouldScrollToIndex ? optionSize && getFocusedOptionIndex(options) : -1;
      return /*#__PURE__*/React.createElement(AutoSizer, {
        ref: this.autoSizerRef,
        disableHeight: true
      }, function (_ref2) {
        var width = _ref2.width;
        return /*#__PURE__*/React.createElement(List, {
          css: getStyles('menuList', _this2.props),
          height: height !== null && height !== void 0 ? height : _min([maxHeight, menuHeight]),
          width: width,
          deferredMeasurementCache: _this2.cache,
          rowHeight: _this2.cache.rowHeight,
          rowCount: optionSize,
          rowRenderer: _this2.renderMenuListItem,
          noRowsRenderer: _this2.renderPlaceholder,
          overscanRowCount: OVERSCAN_ROW_COUNT,
          scrollToIndex: focusedOptionIndex,
          ref: _this2.listRef
        });
      });
    }
  }]);
  return MenuList;
}(PureComponent);
MenuList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
  getStyles: PropTypes.func,
  maxHeight: PropTypes.number.isRequired,
  shouldScrollToIndex: PropTypes.bool,
  height: PropTypes.number
};
MenuList.defaultProps = {
  getStyles: _noop,
  shouldScrollToIndex: true,
  height: undefined
};
export default MenuList;